<template>
    <div class="wxProperty">
        <div class="propertyContent">
            <h1 :class="{'state_blue':formInline.state=='在用','state_red':formInline.state=='已报废','state_yellow':formInline.state=='待报废'}">资产状态：{{formInline.state}}</h1>
            <div class="banner" style="width: 100%;height: auto">
                <img :src=imgSrc style="width: 100%;height: auto" alt="">
            </div>
            <div class="main">
                <h2 style="text-indent: 20px;text-align: left;color: #847c7c;">资产信息描述</h2>
                <p style="text-indent: 20px;text-align: left">{{formInline.remarks}}</p>
                <div class="property_type"><span>资产类别</span><span style="margin-left: 19%;">{{formInline.name}}</span> <a  @click="toRoute" style="margin-left: 10%;"><span style="margin-right: 10px;"> 同类别</span></a></div>
            </div>
            <div class="property_msg">
                <img src="../../assets/wxScrap.png" v-if="formInline.state=='已报废'" style="width: 278px;height: 243px;position: absolute;top: auto;right: 0;display: inline-block" alt="">
                <table border="1" cellspacing="0" style="z-index: 999;border: 1px solid #c1c1c1;">
                    <tr>
                        <td class="title" align="left">资产名称</td>
                        <td align="left">{{formInline.name}}</td>
                        <!--<td align="left">戴尔台式电脑</td>-->
                    </tr>
                    <tr>
                        <td class="title" align="left">所属部门</td>
                        <td align="left">{{formInline.department}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">资产数量</td>
                        <td align="left">{{formInline.count}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">计量单位</td>
                        <td align="left">{{formInline.unit}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">规格型号</td>
                        <td align="left">{{formInline.model}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">净值</td>
                        <td align="left">{{formInline.net_value}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">资产原值</td>
                        <td align="left">{{formInline.full_price}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">累计折旧</td>
                        <td align="left">{{formInline.depreciation}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">用友系统卡片编号</td>
                        <td align="left">{{formInline.yonyou_id}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">行政事业系统编号</td>
                        <td align="left">{{formInline.admin_id}}</td>
                        <!--<td align="left">197018003-2010104-000030</td>-->
                    </tr>
                    <tr>
                        <td class="title" align="left">项目名称</td>
                        <td align="left">{{formInline.project_name}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">增加日期</td>
                        <td align="left">{{formInline.add_date}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">增加方式</td>
                        <td align="left">{{formInline.add_type}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">资金来源</td>
                        <td align="left">{{formInline.fund_source}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">发票编号</td>
                        <td align="left">{{formInline.invoice_number}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">入账日期</td>
                        <td align="left">{{formInline.entry_date}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">入账形式</td>
                        <td align="left">{{formInline.entry_type}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">会计凭证号</td>
                        <td align="left">{{formInline.accounting_id}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">财务负责人</td>
                        <td align="left">{{formInline.finance_person}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">实物保管人</td>
                        <td align="left">{{formInline.keeper}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">所属单位</td>
                        <td align="left">{{formInline.company}}</td>
                        <!--<td align="left">广东省水文局佛山水文分局</td>-->
                    </tr>
                    <tr>
                        <td class="title" align="left">存放地点</td>
                        <td align="left">{{formInline.location}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">建筑面积（㎡）</td>
                        <td align="left">{{formInline.build_area}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">使用年限</td>
                        <td align="left">{{formInline.use_year}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">使用状态</td>
                        <td align="left">{{formInline.usr_state}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">销帐日期</td>
                        <td align="left">{{formInline.cancel_date}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">注销人</td>
                        <td align="left">{{formInline.cancel_person}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">变动日期</td>
                        <td align="left">{{formInline.change_date}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">变动后使用部门</td>
                        <td align="left">{{formInline.change_dep}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">生产厂家</td>
                        <td align="left">{{formInline.manufacturer}}</td>
                    </tr>
                    <tr>
                        <td class="title" align="left">供应商</td>
                        <td align="left">{{formInline.supplier}}</td>
                    </tr>
                </table>
            </div>

        </div>

    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import wxNav from "../wxNav"
    export default {
        props: ["wxCode","id"],
        data () {
          return{

                imgSrc:"",
                formInline:{
                    state:"",
//                    imgSrc:"",
                    remarks:"",
                    name:"",
                    department:"",
                    count:"",
                    model:"",
                    net_value:"",
                    full_price:"",
                    depreciation:"",
                    yonyou_id:"",
                    admin_id:"",
                    add_date:"",
                    class_code:"",
                    add_type:"",
                    unit:"",
                    fund_source:"",
                    invoice_number:"",
                    accounting_id:"",
                    finance_person:"",
                    entry_date:"",
                    entry_type:"",
                    project_name:"",
                    keeper:"",
                    company:"",
                    location:"",
                    build_area:"",
                    use_year:"",
                    usr_state:"",
                    cancel_date:"",
                    cancel_person:"",
                    change_date:"",
                    change_dep:"",
                    manufacturer:"",
                    supplier:"",
                },

            }
        },
        components:{
            wxNav
        },
        computed: {
		    ...mapState(["enter"]),
		},
        methods:{
            ...mapMutations(["CHANGE_ENTER"]),
            //第一次进入获取人员信息
            getPerson() {
                var that = this;
                let params = {};
                params.url = "/manage/xiaocx/getopenId?code="+that.wxCode;
                params.token = "swgykj9527";
                that.showIt = params
                params.success=function(res){
//                    alert('loadData:'+JSON.stringify(res))
                    window.localStorage.setItem("wxCode",res.data.result.xcx_openId);
                    if(res.data.code == "8888"){
                        window.localStorage.setItem("isLogin","false");
                        that.$router.replace('/data/wxSend/'+res.data.result.xcx_openId);
                        that.CHANGE_ENTER(that.id);
                    }else if(res.data.code == "0000"){
                        window.localStorage.setItem("isLogin","true");
//                        alert(JSON.stringify(res))
                        that.loadData()
//                        that.formInline.realname = res.data.result.username;
//                        that.username = res.data.result.username;
//                        that.searchDinner();
                    }
                };
                that.ajaxPostWX(params);
            },
            getPerson2() {
                let that = this;
                let params = {};
                params.data = {
                    searchValue: {
                        "xcx_openId": window.localStorage.getItem("wxCode")
                    }
                };
                params.url = "/sys/userinfo/list";
                params.token = "swgykj9527";
                params.success = function(res) {
                	window.localStorage.setItem("wxCode",res.data.result.xcx_openId);
                    if(res.data.code == "8888"){
                        window.localStorage.setItem("isLogin","false");
                        that.$router.replace('/data/wxSend/'+res.data.result.xcx_openId);
                        that.CHANGE_ENTER(that.id);
                    }else if(res.data.code == "0000"){
                        window.localStorage.setItem("isLogin","true");
//                        alert(JSON.stringify(res))
                        that.loadData()
//                        that.formInline.realname = res.data.result.username;
//                        that.username = res.data.result.username;
//                        that.searchDinner();
                    }
                };
                that.ajaxPostWX(params);
            },
            toRoute(){
//                console.log(window.localStorage.getItem("wxCode"));
//              alert(this.formInline.class_code)
                this.$router.push('/data/wxAllProperty/'+window.localStorage.getItem("wxCode")+'/'+this.formInline.class_code);
            },
            loadData:function () {
                var that = this;
                var params = {};
                params.data = {
                    searchValue:{id:this.id +'|#|like'}
                };
                params.token = "swgykj9527";
                console.log(params.data);
                params.url = '/sys/assetlist/list';
                params.success = function(res) {
                    that.$Loading.finish();
//                    alert('loadData:'+JSON.stringify(res))
                    console.log(res);
                    that.formInline=res.data.result.result[0]
                    that.imgSrc=parameters.domain+res.data.result.result[0].asset_image[0]+'?token=swgykj9527';

                }
                this.ajaxPostWX(params);
            },
        },
        mounted: function() {
            console.log(this.id);
//            alert(this.id)
//            alert(window.localStorage.getItem("wxCode"))
//            if(this.id!=''){
////                alert('有id')
////                alert(this.id)
//                alert(this.wxCode)
//                window.localStorage.setItem("wuId",this.id);
//            }else{
//                alert('没有id')
//                alert(window.localStorage.getItem("wuId"))
//                this.id=window.localStorage.getItem("wuId")
//            }

            console.log(window.localStorage.getItem("wxCode"));
//            alert('传两个参数id:'+this.id+'--------code:'+this.wxCode)
//            if(window.localStorage.getItem("wxCode") == this.wxCode){
//                this.getPerson2();
//            }else{
//                this.getPerson();
//            }
            if(window.localStorage.getItem("wxCode")==this.wxCode ||window.localStorage.getItem("wxCode")!=''){
//                alert(6666)
                this.loadData()
            }else if(this.wxCode == "000"){
//                alert(77777)
            	this.getPerson2()
            }else{
//                alert(8888)
                this.getPerson();
            }

//            this.loadData()
        }
    }
</script>

<style lang="scss">
    .wxProperty{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
        /*max-width: 768px;*/
        margin: 0 auto;
        background-color: #efefef;
        text-align: center;
        .propertyContent{
            width: 90%;
            margin: 0 auto;
            height: 100%;
            background-color: #fff;
            .state_blue{
                color: #00c0ff;
            }
            .state_red{
                color: red;
            }
            .state_yellow{
                color: #ffc937;
            }
        }
        .property_msg{
            position: relative;
            width: 100%;
            table{
                width: 100%;
                font-size: 16px;
                line-height: 30px;
                .title{
                    color: #847c7c;
                }
                tr td{
                    padding-left: 5px;
                }
            }
        }
        .main{
            font-size: 14px;
            .property_type{
                font-size: 16px;
                padding-left: 5px;
                text-align: left;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/propertyMana/wxProperty.vue